export const slugTagNameMap = [
  {
    slug: "kyb-workflow-automation",
    tag: "KYB Workflow Automation",
  },
  {
    slug: "kyb",
    tag: "KYB Workflow Automation",
  },
  {
    slug: "kyc-Workflow-automation",
    tag: "KYC Workflow Automation",
  },
  {
    slug: "kyc",
    tag: "KYC Workflow Automation",
  },
  {
    slug: "application-pre-fill",
    tag: "Application Pre-fill",
  },
  {
    slug: "prefill",
    tag: "Application Pre-fill",
  },
  {
    slug: "business-decision-making",
    tag: "Business Decision-making",
  },
  {
    slug: "lead-targeting",
    tag: "Lead Targeting",
  },
  {
    slug: "portfolio-monitoring",
    tag: "Portfolio Monitoring",
  },
  {
    slug: "lead-enrichment",
    tag: "Lead Enrichment",
  },
  {
    slug: "leads",
    tag: "Lead Enrichment",
  },
  {
    slug: "credit-score-consolidation",
    tag: "Credit Score Consolidation",
  },
  {
    slug: "credit",
    tag: "Credit Score Consolidation",
  },
  {
    slug: "buy-now-pay-later",
    name: "Buy Now Pay Later",
  },
  {
    slug: "ecommerce",
    name: "eCommerce",
  },

  {
    slug: "retail",
    name: "Retail",
  },
  {
    slug: "marketing",
    name: "Marketing",
  },
  {
    slug: "insurance",
    name: "Insurance",
  },
  {
    slug: "financial-services",
    name: "Financial Services",
  },
];

export const slugTagCategoryMap = [
  {
    slug: "use-case",
    tag: "Use-Case",
  },
  {
    slug: "industry",
    tag: "Industry",
  },
];

export const slugRegionMap = [
  {
    slug: "united-states",
    region: "United States",
    adjective: "American",
  },
  {
    slug: "united-kingdom",
    region: "United Kingdom",
    adjective: "British",
  },
  {
    slug: "australia",
    region: "Australia",
    adjective: "Australian",
  },
  {
    slug: "philippines",
    region: "Philippines",
    adjective: "Philippine",
  },
  // nice typo, geniuses
  {
    slug: "phillippines",
    region: "Phillippines",
    adjective: "Phillippine",
  },
  {
    slug: "global",
    region: "Global",
    adjective: "Worldwide",
  },
  {
    slug: "new-zealand",
    region: "New Zealand",
    adjective: "New Zealand",
  },
  {
    slug: "canada",
    region: "Canada",
    adjective: "Canadian",
  },
  {
    slug: "india",
    region: "India",
    adjective: "Indian",
  },
  {
    slug: "germany",
    region: "Germany",
    adjective: "German",
  },
  {
    slug: "mexico",
    region: "Mexico",
    adjective: "Mexican",
  },
  {
    slug: "indonesia",
    region: "Indonesia",
    adjective: "Indonesian",
  },
  {
    slug: "singapore",
    region: "Singapore",
    adjective: "Singaporean",
  },
  {
    slug: "malaysia",
    region: "Malaysia",
    adjective: "Malaysian",
  },
  {
    slug: "france",
    region: "France",
    adjective: "French",
  },
  {
    slug: "spain",
    region: "Spain",
    adjective: "Spanish",
  },
  {
    slug: "vietnam",
    region: "Vietnam",
    adjective: "Vietnamese",
  },
  {
    slug: "thaliand",
    region: "Thaliand",
    adjective: "Thai",
  },
  {
    slug: "hong-kong",
    region: "Hong Kong",
    adjective: "Hongkongese",
  },
];

export const availableAcronyms = ["kyb", "kyc", "b2b"];

export const availableCustomCaseWords = ["eCommerce", "SaaS", "DaaS"];

export const sanitizeSlug = (slug, type = "titlecase") => {
  if (!slug) return null;

  const capitalizeAcronyms = string => {
    let acrononymsOrred = availableAcronyms.join("|");
    let regex = new RegExp(acrononymsOrred, "ig");

    return string.replace(regex, match => match.toUpperCase());
  };

  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.substr(1).toLowerCase();
  };

  const setCustomCase = string => {
    let availbleCustomWordsOrred = availableCustomCaseWords.join("|").toLowerCase();
    let regex = new RegExp(availbleCustomWordsOrred, "ig");

    return string.replace(
      regex,
      match =>
        availableCustomCaseWords.filter(item => item.toLowerCase() === match.toLowerCase())[0],
    );
  };

  const toTitleCase = string => {
    return string
      .replace(/---/g, " _ ") // first convert three straight hyphens to temp _
      .replace(/-/g, " ") // then replace all hyphens
      .replace(/_/g, "-") // then turn temp _ back to a hyphen
      .replace(/,/g, "") // remove commas
      .replace(/\w\S*/g, text => capitalizeFirstLetter(text)); // finally titleCase
  };

  if (type === "titlecase") {
    let title = toTitleCase(slug);
    title = capitalizeAcronyms(title);
    title = setCustomCase(title);

    return title;
  }

  if (type === "tagName") {
    let [slugToTag] = slugTagNameMap.filter(item => item.slug === slug).map(item => item.tag);
    if (slugToTag) {
      return slugToTag;
    }

    let tagAlt = toTitleCase(slug);
    tagAlt = capitalizeAcronyms(tagAlt);
    tagAlt = setCustomCase(tagAlt);

    return tagAlt;
  }

  if (type === "tagCategory") {
    let [slugToTag] = slugTagCategoryMap.filter(item => item.slug === slug).map(item => item.tag);

    if (slugToTag) {
      return slugToTag;
    }

    let tagAlt = toTitleCase(slug);
    tagAlt = capitalizeAcronyms(tagAlt);
    tagAlt = setCustomCase(tagAlt);

    return tagAlt;
  }

  if (type === "region") {
    let [slugToRegion] = slugRegionMap.filter(item => item.slug === slug).map(item => item.region);

    if (slugToRegion) {
      return slugToRegion;
    }

    let regionAlt = toTitleCase(slug);
    regionAlt = capitalizeAcronyms(regionAlt);
    regionAlt = setCustomCase(regionAlt);

    return regionAlt;
  }

  if (type === "regionAdjective") {
    let [slugToRegion] = slugRegionMap
      .filter(item => item.slug === slug)
      .map(item => item.adjective);

    if (slugToRegion) {
      return slugToRegion;
    }

    let regionAlt = toTitleCase(slug);
    regionAlt = capitalizeAcronyms(regionAlt);
    regionAlt = setCustomCase(regionAlt);

    return regionAlt;
  }

  if (type === "sentence") {
    let sentence = capitalizeFirstLetter(slug);
    sentence = capitalizeAcronyms(sentence);
    sentence = setCustomCase(sentence);
    return sentence;
  }

  if (type === "sentenceLowerCase") {
    let sentence = slug.toLowerCase();
    sentence = capitalizeAcronyms(sentence);
    sentence = setCustomCase(sentence);

    return sentence;
  }

  let title = toTitleCase(slug);
  title = capitalizeAcronyms(title);
  title = setCustomCase(title);

  return title;
};
